import TextArea from '@/molecules/TextArea.vue';
import defaultValidators from '@/helpers/default-validators';
import SpecialistSelector from '@/parcours/components/specialistSelector.vue';
import { withGlobalFlow } from '@/parcours/flowGlobalSteps';
import { usePreventionParcours } from '@/parcours/composables/usePreventionParcours';
import HealthWomenReport from '@/parcours/flows/HealthWomenReport.vue';

const { update, getById } = usePreventionParcours('/cms/coordinator-patient-health-women-infos');

export const healthWomenFlow = withGlobalFlow({
  id: 'healthWomenFlow',

  basePath: '/healthWomenFlow/flow',

  exitRoute: '/healthWomenFlow',

  async onInit({ route }) {
    const id = route.params.reservationId;
    const data = await getById(id);
    return { ...data };
  },

  steps: {
    report: {
      id: 'theme',
      type: 'component',
      component: HealthWomenReport,
      title: 'Thématique à aborder',
      props: (data: any) => ({
        theme: data.flowData?.theme,
      }),
    },
    preview: {
      id: 'other_specialists',
      type: 'component',
      title: 'Recommandations',
      description:
        "Je recommande au patient d'aller consulter le(s) professionnel(s) de santé suivant(s):",
      component: SpecialistSelector,
      props: {
        specialists: [
          { name: 'Gynécologue', value: 'Gynécologue' },
          { name: 'Médecin généraliste', value: 'Médecin généraliste' },
          { name: 'Sage-femme', value: 'Sage-femme' },
          { name: 'Endocrinologue', value: 'Endocrinologue' },
          { name: 'Radiologue', value: 'Radiologue' },
          { name: 'Sexologue', value: 'Sexologue' },
          { name: 'Kinésithérapie', value: 'Kinésithérapie' },
          { name: 'Ostéopathe', value: 'Ostéopathe' },
          { name: 'Diététicien, nutritionniste', value: 'Diététicien, nutritionniste' },
          { name: 'Autre', value: 'Autre' },
          { name: 'Aucun', value: 'Aucun' },
        ],
      },
    },
    lastComment: {
      type: 'form',
      title: 'Un dernier commentaire ?',
      description: 'Autre commentaire ou recommandation pour le patient',
      schema: {
        validateOnChange: false,
        validateOnBlur: true,
        fields: [
          {
            id: 'other_recommendations',
            type: 'textarea',
            placeholder: 'Votre commentaire ...',
            as: TextArea,
            rules: defaultValidators.textOpt,
          },
        ],
      },
    },
  },

  transitions: {
    report: { next: 'preview' },
    preview: { next: 'lastComment' },
    lastComment: { submit: true },
  },

  async onSubmit(data) {
    await update(data?.id, data);
  },
});
